/**
 * CoSingery — 品牌標記（產品負責人 2026-09-23 交嘅 logo：**開放嘅書 ＋ 橫貫心跳波形線**）
 *
 * 為何要一個元件（唔係淨係用 PNG）：介面內要用**任何尺寸都清晰**嘅版本 ——
 *   點陣圖放大只會更糊，所以呢個檔同 `scripts/make-pwa-icons.mjs` **用同一套幾何**
 *   （書 ＋ 波形線；改形狀＝改品牌 → **兩邊一齊改**，見 `decisions/032`）。
 *
 * ⚠️ 顏色：
 *   · 線 ＝ `currentColor`（跟父層文字色；淺底上唔會消失）
 *   · `field` 版嘅底 ＝ `var(--color-brand)`（`tokens.css` 唯一品牌色；唔准喺呢度自創色）
 */
export interface BrandMarkProps {
  /** 邊長（px） */
  size?: number;
  /** 連底一齊畫（深棗紅圓角方 ＋ 白線）—— 用喺淺色底／卡片上 */
  field?: boolean;
  /** 讀屏器用嘅名（裝飾用途可以傳空字串） */
  title?: string;
}

/**
 * 幾何（100×100 座標；同產生器嘅 art space ×100 一致）
 *   · `LEAF` ＝ 一頁（閉合）；`THICK` ＝ 右頁外緣多一條線（書頁厚度）
 *   · `WAVE` ＝ 心跳波形（左中段大起大落 → 向右遞減到平）
 */
const LEAF = {
  left: 'M50 37.2 C43 34.8 33 31.8 26.2 31.8 L26.2 63.2 C33 66 43 70 50 70 Z',
  right: 'M51.4 38.4 C58.4 36 68.4 33 75.2 33 L75.2 64.4 C68.4 67.2 58.4 71.2 51.4 71.2 Z',
  thick: 'M78.2 33.8 L78.2 64.8',
};
const WAVE =
  'M15 50.5 L23.8 50.5 L26.2 52 L28.6 50.5 L30.6 54.5 L32.2 43 L33.4 56 L34.6 47 L36 64 ' +
  'L38.6 36 L40.4 58 L42.8 45 L44.6 58.5 L46.2 48 L48.6 56 L50.6 49.2 L53 54.8 L55.2 49.8 ' +
  'L57.6 53.8 L60 50 L63 52.2 L66 49.8 L70 50.8 L76 50 L86 50';

export default function BrandMark({ size = 40, field = false, title = 'CoSingery' }: BrandMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      role="img"
      aria-label={title}
      data-testid="brand-mark"
      style={{ display: 'block', flex: '0 0 auto' }}
    >
      {field ? <rect x="0" y="0" width="100" height="100" rx="22" fill="var(--color-brand, #4b1120)" /> : null}
      <g
        fill="none"
        stroke={field ? 'var(--color-on-primary, #ffffff)' : 'currentColor'}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d={LEAF.left} />
        <path d={LEAF.right} />
        <path d={LEAF.thick} />
        <path d={WAVE} strokeWidth="1.45" />
      </g>
    </svg>
  );
}
